"use client";

import { Canvas } from "@react-three/fiber";
import { cn } from "@repo/ui/lib/utils";

import Scene from "./Scene";

export default function RetroContainer({
  children,
  classname,
}: Readonly<{
  children?: React.ReactNode;
  classname?: string;
}>) {
  return (
    <div className={cn(classname)}>
      {children}
      <Canvas
        gl={{
          preserveDrawingBuffer: true,
          antialias: true,
        }}
      >
        <Scene />
      </Canvas>
    </div>
  );
}
